import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'src/store/selectors';
import { configuration } from 'src/configuration';
import { getCodesetsbyDataSourceId, getCodesets, getCodesetById } from './codesets';
import { CodesetResponse, CodesetsQueryDTO } from 'src/types/codesets';

export function useGetCodesetsByDataSourceId(dataSourceId: string | undefined, codesetId?: string) {
  const token = useSelector(selectAuthToken);

  return useQuery<CodesetsQueryDTO | null>({
    queryKey: ['codesets-cohorts', dataSourceId, codesetId],
    queryFn: async () => {
      if (dataSourceId) {
        return await getCodesetsbyDataSourceId({ token, dataSourceId, codesetId });
      }
      return null;
    },
    staleTime: configuration.queriesStaleTime,
  });
}

export function useGetCodesets(codesetId?: string) {
  const token = useSelector(selectAuthToken);

  return useQuery<CodesetsQueryDTO | null>({
    queryKey: ['codesets-cohorts', codesetId],
    queryFn: async () => await getCodesets({ token, codesetId }),
    staleTime: configuration.queriesStaleTime,
  });
}

export function useGetCodesetById(
  codesetId: string,
  options?: Omit<UseQueryOptions<CodesetResponse | null>, 'queryKey' | 'queryFn'>,
) {
  const token = useSelector(selectAuthToken);

  return useQuery<CodesetResponse | null>({
    queryKey: ['codeset', codesetId],
    queryFn: async () => getCodesetById({ token, codesetId }),
    staleTime: configuration.queriesStaleTime,
    ...options,
  });
}
